import { Trans } from '@lingui/macro';
import { DEFAULT_REDIRECT_URI } from '../../constants';
import React from 'react';
export default function ChangeEmailSuccess(props) {
  const { token } = props;

  const redirectToHome = () => {
    const redirect = DEFAULT_REDIRECT_URI;
    const pathArr = redirect.split('/');
    const domain =
      pathArr.length > 3 ? `${pathArr[0]}//${pathArr[2]}` : redirect;
    const stringQuery = new URLSearchParams();
    stringQuery.append('token', token);
    stringQuery.append('url', redirect);
    console.log(`${domain}/redirect?${stringQuery.toString()}`);
    window.location.href = `${domain}/redirect?${stringQuery.toString()}`;
  };

  return (
    <div className="flex flex-col items-center w-full text-slate-600">
      <div className="w-auto font-bold text-3xl mb-[20px]">
        <Trans>Bạn đã đổi email thành công</Trans>
      </div>
      <div className='flex justify-center'>
        <button
          onClick={() => redirectToHome()}
          className="px-5 py-2 text-white transition duration-300 rounded bg-luat_HN_primary hover:bg-luat_HN_primary_hover text-[20px]"
        >
          <Trans>Quay lại trang chủ</Trans>
        </button>
      </div>
    </div>
  );
}
